<template>
  <v-card>
    <Cabecera 
      v-if="!incrustado" 
      tipoModuloActual="pago"
      :incrustado="incrustado"/>
    <StepperPortal v-if="!incrustado" tipoModuloActual="pago" />
    <v-container fluid>
      <o-big-title v-if="incrustado">{{titulo}}</o-big-title>
      <o-base-justify-text  v-if="reserva.importeReserva > 0">
          {{
            $t('reservas.pagos.pagoTexto', {
              pago: pagoVer ? $t('reservas.pagos.realizado') : $t('reservas.pagos.vaRealizar'),
              realizar: pagoVer ? '' : pagoRevisando ? $t('reservas.pagos.revisar') : $t('reservas.pagos.realizar'),
              inmueble: inmueble.descripcionLarga,
              promo: promocion.descripcion,
              reserva: $options.filters['currency'](reserva.importeReserva)
            })
          }}
      </o-base-justify-text>
      <o-base-justify-text v-if="!pagoVer && !pagoRevisando && reserva.importeReserva > 0">
        <v-layout column>
          <span v-if="moduloOrden.tiposPago === 'ambos'">{{$t('reservas.pagos.pagoDosFormas')}}</span>
          <span v-if="moduloOrden.tiposPago === 'stripe' || moduloOrden.tiposPago === 'ambos'" v-html="getTexto('pago.tarjeta', reserva.codigoPromocion)"/><br/>
          <span v-if="moduloOrden.tiposPago === 'transferencia' || moduloOrden.tiposPago === 'ambos'" v-html="getTexto('pago.transferencia', reserva.codigoPromocion)"/>
        </v-layout>
      </o-base-justify-text>
      <!-- Resultado de validación -->
      <v-layout v-if="pagoRechazado && reserva.pago.motivoRechazo" column>
        <o-medium-title>{{$t('reservas.pagos.validacion')}}</o-medium-title>
        <o-base-justify-text>
          {{$t('reservas.pagos.pagoRechazado')}}
        </o-base-justify-text>
        <o-base-justify-text colorClass="error--text">
          {{$t('reservas.pagos.comentarioRevisor')}}
        </o-base-justify-text>
        <o-base-justify-text colorClass="error--text" style="white-space: pre-line">{{
          reserva.pago.motivoRechazo
        }}</o-base-justify-text>
        <o-base-justify-text v-if="moduloOrden.tiposPago === 'stripe'">
          {{$t('reservas.pagos.rePagar')}}
        </o-base-justify-text>
        <o-base-justify-text v-if="moduloOrden.tiposPago === 'transferencia'">
          {{$t('reservas.pagos.rectificarDoc')}}
        </o-base-justify-text>
        <o-base-justify-text v-if="moduloOrden.tiposPago === 'ambos'">
          {{$t('reservas.pagos.rectificarOPagar')}}
        </o-base-justify-text>
      </v-layout>
      <o-medium-title v-if="reserva.importeReserva > 0">
        {{pagoVer ? $t('reservas.pagos.informacion') : pagoRevisando ? $t('reservas.pagos.transferencia') : $t('reservas.pagos.seleccioneMetodo')}}
      </o-medium-title>   
      <!-- Contenido en revisión -->  
      <v-flex 
        v-if="pagoRevisando"
        xs12 lg6 xl6 px-2
        class="mb-2"
      >
        <v-layout row wrap>
          <v-flex 
            xs12 sm9 md8 lg8 xl8
            class="subheading" 
            :class="[
              !justificanteValido ? 'error--text' : 'grey--text text--darken-1',
              $vuetify.breakpoint.smAndUp ? 'pr-4' : ''
            ]"
          >
            {{$t('reservas.pagos.transferenciaValor', {reserva: $options.filters['currency'](reserva.importeReserva)})}}<br/>
            <!-- eslint-disable-next-line -->
            {{promocion.cuentaTransferencia ? promocion.cuentaTransferencia.valor : ''}}<br/>
          </v-flex>
          <v-flex shrink :mt-3="$vuetify.breakpoint.xsOnly">
            <FileUploader
              style="height:168px; width: 200px"
              :maxNum="1"
              :value="justificante"
              :deletable="false"
              :disabled="true"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <div v-else>
        <o-base-justify-text v-if="pagoVer && reserva.pago && reserva.pago.tipo === 'stripe'">
          {{$t('reservas.pagos.pagoRealizado', {reserva: $options.filters['currency'](reserva.importeReserva), fecha: $options.filters['formatDate'](reserva.pago.fechaAlta), pago: reserva.pago.ultimosCuatro, estadoPago: reserva.estadoPago.codigoEstadoPago === 10 ? $t('reservas.pagos.importeNoRetirada') : ''})}}
        </o-base-justify-text>
        <v-form ref="form" v-model="valid" v-else-if="reserva.importeReserva > 0">
          <v-radio-group  
            row class="pa-0 fullWidth" 
            v-model="metodo"
            :disabled="disabled || pagoReadonly"
            :rules="[rules.required]"
          >
            <v-layout mb-3 row wrap justify-center >
              <v-flex xs12 lg6 xl6 px-2 v-if="moduloOrden.tiposPago === 'stripe' || moduloOrden.tiposPago === 'ambos'">
                <v-radio
                  :label="$t('reservas.pagos.tarjeta')"
                  value="stripe"
                  color="primary"
                  :class="$vuetify.breakpoint.xsOnly ? 'mb-3' : ''"
                />
                <div :style="metodo !== 'stripe' ? divDesactivada : {}">
                  <!-- <v-layout class="j-stripe" align-center style="margin-bottom:20px;">
                    <v-flex hidden-xs-only sm3 md2 lg2 xl2>
                      <v-img :src="require('@/assets/tarjeta2.png')" contain/>
                    </v-flex>
                    <v-flex xs12 offset-sm1 sm8 offset-md1 md9 offset-lg1 lg8 offset-xl1 xl8>
                      <v-layout>
                        <v-flex xs12>
                          <div class="j-stripe-field">
                            <div id="cardNumber" class="j-stripe-input empty"></div>
                            <label class="primary--text" for="cardNumber">Número de tarjeta</label>
                            <div class="j-stripe-baseline"><div class="j-stripe-baseline2 primary"></div></div>
                            <div class="j-stripe-errors">
                              <div id="cardNumber-error" class="j-stripe-error-message"></div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs8 sm6 md6 lg6 xl4>
                          <div class="j-stripe-field">
                            <div id="expirationDate" class="j-stripe-input empty"></div>
                            <label class="primary--text" for="expirationDate">Fecha de caducidad</label>
                            <div class="j-stripe-baseline">
                              <div class="j-stripe-baseline2 primary"></div>
                            </div>
                            <div class="j-stripe-errors">
                              <div id="expirationDate-error" class="j-stripe-error-message"></div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex offset-xs1 xs3 offset-sm4 sm2 offset-md4 md2 lg2 offset-lg4 offset-xl6>
                          <div class="j-stripe-field">
                            <div id="card-cvc" class="j-stripe-input empty"></div>
                            <label class="primary--text" for="card-cvc">CVC</label>
                            <div class="j-stripe-baseline"><div class="j-stripe-baseline2 primary"></div></div>
                            <div class="j-stripe-errors">
                              <div id="card-cvc-error" class="j-stripe-error-message"></div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout> -->
                  <v-layout align-center>
                    <v-flex hidden-xs-only sm2 md2 lg2 xl2 px-2>
                      <v-img :src="require('@/assets/tarjeta2.png')" contain/>
                    </v-flex>
                    <v-flex xs12 offset-sm1 sm6 offset-md1 md5 offset-lg1 lg6 offset-xl1 xl4 px-2>
                      <v-layout align-start>
                        <v-flex>
                          <v-text-field
                            :label="$t('reservas.pagos.nombreTitular')"
                            :rules="[rules.required]"
                            v-model="cardName"
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout align-start>
                        <v-flex>
                          <v-text-field
                            :label="$t('reservas.pagos.numTarjeta')"
                            :rules="rulesTarjeta"
                            v-model="cardNumber"
                            mask="#### #### #### ####"
                            placeholder="1234 1234 1234 1234"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout align-center row mb-2 mt-1>
                    <v-flex xs6 offset-sm3 sm3 offset-md3 md2 offset-lg3 lg3 offset-xl3 xl2 px-2>
                      <v-text-field
                        :label="$t('reservas.pagos.fechaCaducidad')"
                        :rules="rulesFecha"
                        v-model="auxExp"
                        mask="##/####"
                        :return-masked-value="true"
                        placeholder="12/1234"
                      />
                    </v-flex>
                    <v-flex xs6 sm3 offset-md1 md2 offset-lg0 lg3 offset-xl1 xl2 px-2>
                      <v-text-field
                        :label="$t('reservas.pagos.cvc')"
                        :rules="rulesCvc"
                        v-model="cardCvc"
                        mask="###"
                        :return-masked-value="true"
                        placeholder="123"
                      />
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
              <v-flex xs12 lg6 xl6 px-2 v-if="moduloOrden.tiposPago === 'transferencia' || moduloOrden.tiposPago === 'ambos'">
                <v-radio
                  :label="$t('reservas.pagos.transferenciaBancaria')"
                  value="transferencia"
                  color="primary"
                />
                <div :style="metodo !== 'transferencia' ? divDesactivada : {}">
                  <v-layout align-center row wrap>
                    <v-flex xs12 sm8 md8 lg8 xl8 class="subheading" :class="!justificanteValido ? 'error--text' : 'grey--text text--darken-1'">
                        {{$t('reservas.pagos.transferenciaTexto', {reserva: $options.filters['currency'](reserva.importeReserva)})}}<br/>
                        <!-- eslint-disable-next-line -->
                        {{promocion.cuentaTransferencia ? promocion.cuentaTransferencia.valor : ''}}<br/>
                        {{$t('reservas.pagos.justificante')}}
                    </v-flex>
                    <v-flex :mt-3="$vuetify.breakpoint.xsOnly" xs12 offset-sm1 sm3 offset-md1 md3 offset-lg1 lg3 offset-xl1 xl3>
                      <FileUploader
                        style="min-height:140px"
                        :style="metodo === 'transferencia' ? 'pointer-events: auto;' : ''"
                        :maxNum="1"
                        uploadFieldName="justificante[]"
                        v-model="justificante"
                        :deletable="!pagoReadonly"
                        :disabled="pagoVer || pagoRevisando"
                        :interactable="pagoVer || pagoRevisando || metodo == 'transferencia'"
                      />
                    </v-flex>
                    <v-flex
                      xs12 sm6 md6 lg5 
                      v-if="pagoRechazado && reserva.pago.motivoRechazo && reserva.pago.tipo == 'transferencia'"
                      class="error--text mt-1"
                    >
                      {{$t('reservas.pagos.justificanteRechazado')}}
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-radio-group>
        </v-form>
        <o-base-justify-text v-else>
          <!-- eslint-disable-next-line -->
          {{$t('reservas.pagos.noNecesitaPago')}} {{pagoVer ? '' : $t('reservas.pagos.pulseAceptar')}}
        </o-base-justify-text>
      </div>
      <!-- Validador -->
      <v-layout v-if="pagoRevisando" column>
        <o-medium-title>{{$t('reservas.pagos.validacionMinuscula')}}</o-medium-title>
        <o-base-text :marginBottom="false" class="mb-1">
          {{$t('reservas.pagos.valida')}}
        </o-base-text>          
        <v-radio-group
          v-model="validarTodo"
          hide-details
          class="pl-2 mb-4"
        >
          <v-layout>
            <v-radio
              color="primary"
              :label="$t('reservas.pagos.si')"
              :value="true"
              class="mb-0"
            />
            <v-radio
              selected
              color="primary"
              :label="$t('reservas.pagos.no')"
              :value="false"
              class="mb-0"
            />
          </v-layout>
        </v-radio-group>
        <v-slide-y-transition>
          <v-layout v-if="validarTodo === false" column mb-2>
            <o-base-text :marginBottom="false">
              {{$t('reservas.pagos.addComentario')}}
            </o-base-text>
            <v-textarea
              v-model="textoValidacion"
              auto-grow
            />
          </v-layout>
        </v-slide-y-transition>
      </v-layout>
      <!-- Botonera -->
      <v-layout justify-space-between align-center>
        <v-flex xs2>
          <v-btn
            flat
            class="titleColor--text ml-0 pl-0"
            :disabled="waitingForLoad"
            @click="$router.push({
            name: 'reservas.id',
            params: {id: reserva.id}
          })"
            v-if="!incrustado"
            :icon="$vuetify.breakpoint.xsOnly"
          >
            <!-- eslint-disable-next-line -->
            <v-icon class="mr-1">{{$vuetify.breakpoint.xsOnly ? 'arrow_back':'chevron_left'}}</v-icon>
            <span class="hidden-xs-only">{{$t('general.misc.volver')}}</span>
          </v-btn>
        </v-flex>
        <v-layout
          v-if="!pagoVer || incrustado"
          :column="$vuetify.breakpoint.smAndDown" 
          :shrink="$vuetify.breakpoint.smAndDown" 
          justify-space-around
        >
          <v-btn 
            v-if="!pagoRevisando"
            large
            color="primary"
            :disabled="disabled || waitingForLoad || cargandoExterior"
            :loading="waitingForLoad || cargandoExterior"
            @click="aceptar"
          >
            {{metodo === 'stripe' ? $t('reservas.pagos.realizarPago') : $t('reservas.pagos.aceptar')}}
          </v-btn>
          <v-btn 
            v-else
            large
            color="primary"
            :disabled="waitingForLoad || cargandoExterior"
            :loading="waitingForLoad || cargandoExterior"
            @click="validar()"
          >
            {{$t('reservas.pagos.completarRevision')}}
          </v-btn>
        </v-layout>
        <v-flex xs2/>
      </v-layout>
    </v-container>
    <v-fade-transition>
      <custom-dialog v-if="mostrarIframeStripe" v-model="mostrarIframeStripe" :noCerrar="true">
        <pop-up-layout :maxi="true" :ocultarVolver="true">
          <v-layout justify-center>
            <iframe ref="iframe" :src="urlIframeStripe" frameBorder="0" style="min-height:60vh;width:100%"/>
          </v-layout>
        </pop-up-layout>
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog v-if="mostrarStripe" v-model="mostrarStripe" :noCerrar="true">
        <PagoStripe :cargandoExterior="cargandoExterior" @continuar="continuar"/>
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog v-if="mostrarTransferencia" v-model="mostrarTransferencia" :noCerrar="true">
        <PagoTransferencia :incrustado="incrustado" @continuar="continuar"/>
      </custom-dialog>
    </v-fade-transition>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import FileUploader from '@/components/generic/fileUploader/FileUploader'
import PagoStripe from './PagoStripe'
import PagoTransferencia from './PagoTransferencia'
import MixinEstadoPago from '@/mixins/estadosReserva/estadoPago'
import rules from '@/mixins/rules'
import moment from 'moment'
import Cabecera from '@/components/Cabecera'
import StepperPortal from '@/components/StepperPortal'

export default {
  mixins: [rules, MixinEstadoPago],
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    actual: {
      type: Boolean,
      default: true
    }
  },
  components: {
    FileUploader,
    PagoStripe,
    PagoTransferencia,
    Cabecera,
    StepperPortal
  },
  data () {
    return {
      disabled: false,
      metodo: '',
      waitingForLoad: false,
      divDesactivada: {
        pointerEvents: 'none',
        opacity: 0.5
      },
      valid: false,
      justificante: [],
      justificanteValido: true,
      mostrarStripe: false,
      mostrarTransferencia: false,
      stripe: null,
      cardName: null,
      cardNumber: null,
      cardExpMonth: null,
      cardExpYear: null,
      cardCvc: null,
      classes: {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid'
      },
      styles: {
        base: {
          color: 'rgba(0,0,0,0.87)',
          fontWeight: 400,
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: 'rgba(0,0,0,0.38)'
          }
        },
        invalid: {
          color: 'rgba(0,0,0,0.87)'
        }
      },
      mask: 'credit-card',
      auxExp: null,
      error: false,
      validarTodo: null,
      textoValidacion: '',
      mostrarIframeStripe: false,
      urlIframeStripe: ''
    }
  },
  created () {
    window.addEventListener('message', this.comprobarResultadoOK)
    if ((this.reserva.importeReserva > 0 && this.reserva.pago && this.reserva.pago.tipo === 'transferencia') || (this.reserva.importeReserva > 0 && this.moduloOrden.tiposPago === 'transferencia')) {
      if (this.reserva.pago && this.reserva.pago.documento) {
        this.justificante = [this.reserva.pago.documento.documento]
      }
      this.metodo = 'transferencia'
    } else if ((this.reserva.importeReserva > 0 && this.reserva.pago && this.reserva.pago.tipo === 'stripe') || (this.reserva.importeReserva > 0 && this.moduloOrden.tiposPago === 'stripe')) {
      this.metodo = 'stripe'
    } else if (this.reserva.importeReserva <= 0) {
      this.metodo = 'gratis'
    }
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual',
      tarifa: 'reservas/_id/tarifas/getActual',
      inmuebles: 'promociones/inmuebles/getAll',
      modulos: 'modulosOrdenes/modulos/getAll',
      promociones: 'promociones/getAll',
      inmuebleStore: 'promociones/inmuebles/getById',
      promocionStore: 'promociones/getById',
      getModuloOrden: 'modulosOrdenes/getActual'
    }),
    moduloOrden () {
      return this.getModuloOrden
    },
    inmueble () {
      return this.inmuebleStore(this.reserva.codigoActivo, this.reserva.codigoPromocion)
    },
    promocion () {
      return this.promocionStore(this.reserva.codigoPromocion)
    },
    titulo () {
      return this.getTexto('modulos.pago' + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
    },
    justificanteParaApi () {
      const justificantesValidos = this.justificante.filter(x => {
        return (x.id_temporal && x.status === 'SUCCESS') || x.id
      })
      if (justificantesValidos.length === 1) {
        const justificante = {
          nombre: justificantesValidos[0].nombre,
          extension: justificantesValidos[0].extension,
          mime: justificantesValidos[0].mime,
          documentoGrande: justificantesValidos[0].documentoGrande
        }
        if (justificantesValidos[0].id) {
          justificante.id = justificantesValidos[0].id
        }
        return justificante
      } else {
        return null
      }
    },
    rulesTarjeta () {
      let retorno = []
      if (this.metodo === 'stripe') {
        retorno = [
          this.rules.required,
          v => (!!v && v.length === 16) || this.$t('reservas.pagos.formatoIncorrecto'),
        ]
      }
      return retorno
    },
    rulesFecha () {
      let retorno = []
      if (this.metodo === 'stripe') {
        retorno = [
          this.rules.required,
          v => (!!v && v.length === 7) || this.$t('reservas.pagos.formatoIncorrecto'),
          v => (!!v && v.length === 7 && Number(v.split('/')[0]) >= 1 && Number(v.split('/')[0]) <= 12) || this.$t('reservas.pagos.mesIncorrecto'),
          v => (!!v && v.length === 7 && Number(v.split('/')[1]) >= moment().year()) || this.$t('reservas.pagos.anoIncorrecto')
        ]
      }
      return retorno
    },
    rulesCvc () {
      let retorno = []
      if (this.metodo === 'stripe') {
        retorno = [
          this.rules.required,
          v => (!!v && v.length === 3) || this.$t('reservas.pagos.formatoIncorrecto')
        ]
      }
      return retorno
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      pagarStripe: 'pagos/pagarStripe',
      comprobarPagoStripe: 'pagos/comprobarPagoStripe',
      pagarTransferencia: 'pagos/pagarTransferencia',
      pagarGratis: 'pagos/pagarGratis',
      validarPago: 'pagos/validarPago',
      loadPromocion: 'promociones/loadPromocion',
      loadModulosOrdenesActual: 'modulosOrdenes/load'
    }),
    async comprobarResultadoOK (e) {
      if (this.mostrarIframeStripe && e.data === 'OK') {
        try {
          await this.comprobarPagoStripe(this.reserva.id)
          this.mostrarStripe = true
          this.mostrarIframeStripe = false
        } catch (e) {
          this.mostrarIframeStripe = false
          this.addAlert({texto: this.$t('reservas.pagos.pagoError'), color: 'warning'})
        }
      } else if (this.mostrarIframeStripe && e.data === 'KO') {
        this.mostrarIframeStripe = false
        this.addAlert({texto: this.$t('reservas.pagos.pagoError'), color: 'warning'})
      }
    },
    async pagarConStripe () {
      this.waitingForLoad = true
      // Send the token to your server.
      try {
        this.$refs.form.validate()
        if (!this.valid) {
          this.waitingForLoad = false
          this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
          return
        }
        this.urlIframeStripe = null
        this.urlIframeStripe = await this.pagarStripe({
          id: this.reserva.id,
          cardName: this.cardName,
          cardNumber: this.cardNumber,
          cardExpMonth: this.cardExpMonth,
          cardExpYear: this.cardExpYear,
          cardCvc: this.cardCvc
        })
        this.mostrarIframeStripe = true
        this.waitingForLoad = false
      } catch (e) {
        this.waitingForLoad = false
        this.mostrarIframeStripe = false
        this.urlIframeStripe = null
        if (!e.code || (e.code !== 1 && e.code !== 11)) {
          this.addAlert({texto: e.message, color: 'error'})
        } else if (e.code === 11) {
          this.addAlert({texto: this.$t('reservas.pagos.reviseDatos'), color: 'error'})
        }
      }
    },
    async pagarConTransferencia () {
      this.justificanteValido = this.justificanteParaApi !== null
      if (this.justificanteParaApi === null) {
        this.addAlert({texto: this.$t('reservas.pagos.addJustificante'), color: 'error'})
        return
      }
      if (this.reserva.pago && this.reserva.pago.motivoRechazo && this.justificanteParaApi.id != null) {
        this.addAlert({texto: this.$t('reservas.pagos.nuevoJustificante'), color: 'error'})
        return
      }
      this.waitingForLoad = true
      try {
        await this.pagarTransferencia({
          id: this.reserva.id,
          justificante: this.justificanteParaApi
        })
        this.waitingForLoad = false
        this.mostrarTransferencia = true
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    async pagarConGratis () {
      this.waitingForLoad = true
      try {
        await this.pagarGratis(this.reserva.id)
        this.$emit('terminado', this.metodo)
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    async aceptar () {
      switch (this.metodo) {
        case 'stripe':
          await this.pagarConStripe()
          break
        case 'transferencia':
          await this.pagarConTransferencia()
          break
        case 'gratis':
          await this.pagarConGratis()
          break
        default:
          this.addAlert({texto: this.$t('reservas.pagos.metodoPago'), color: 'error'})
          break
      }
    },
    async validar () {
      if (this.validarTodo === null) {
        this.addAlert({texto: this.$t('reservas.pagos.validarTransferencia'), color: 'error'})
        return
      } else if (!this.validarTodo && this.textoValidacion === '') {
        this.addAlert({texto: this.$t('reservas.pagos.rechazarJustificante'), color: 'error'})
        return
      }
      try {
        this.waitingForLoad = true
        await this.validarPago({
          id: this.reserva.id,
          validacion: {
            validado: this.validarTodo,
            textoValidacion: this.textoValidacion
          }
        })
        this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
        this.$emit('terminado', this.metodo)
        this.waitingForLoad = false
      } catch (error) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    },
    continuar () {
      try {
        if (this.metodo === 'stripe') {
          this.$emit('terminado', this.metodo)
        } else if (this.metodo === 'transferencia') {
          this.mostrarTransferencia = false
          this.$emit('terminado', this.metodo)
        }
        if (!this.incrustado) {
          this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
        }
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.comprobarResultadoOK)
  },
  watch: {
    justificanteParaApi (newVal) {
      this.justificanteValido = newVal !== null
    },
    auxExp (value) {
      let expArray = value.split('/')
      this.cardExpMonth = expArray[0]
      this.cardExpYear = expArray[1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/pagos/Pago.vue